import { IReceipt } from "src/domain/entities"
import { receiptListApi } from "../../api/receipt/receiptListApi"

type PayloadShape = Parameters<typeof receiptListApi>[0]

export async function receiptListService(payload: PayloadShape, token?: null | string) {
	const receipt = await receiptListApi(payload, token)
	return receipt as NonNullable<IReceipt[]>
}
